import React from 'react';
import { connect } from 'react-redux';
import { Container, Message, Form, Card, Input} from "semantic-ui-react";
import Select from "react-select";
import lodash from "lodash/core";
import Toggle from "react-toggle";
import {setCountry, setCountryDropdowns, setMatchRates, setProductSupport, updateNotesFieldForCountry} from "../actions/AddEditCountryActions";
import * as Validation from "../../../common/utils/Validation";
import DocumentEditor from "../../../common/partials/DocumentEditor";

const kycStatusOptions = [
    { label: "Alpha", value: "alpha" },
    { label: "Beta", value: "beta" },
    { label: "Production", value: "production" },
];
const kycTierOptions = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
];

const countryOptions = require("../../../common/resources/countries.json");

export class CountryForm extends React.Component {

    componentWillUnmount() {
        this.setState(this.initialState)
    }

    handleSelectCountry = (country) => {
        this.props.selectCountryDropdown(country);
    }

    handleCountryDetailDropdown = (option, change_obj) => {
        this.props.selectKYCDropdown(option, change_obj)
    }

    handleProductSupportToggle = (name) => {
        this.props.toggleProductSupportValue(name)
    }

    handleInputChange = (e, { name, value }) => {
        e.preventDefault();
        this.props.setMatchRates({name, value})
    }

    handleDismiss = () => {
        Validation.clearMessages();
    }

    handleNotesFieldChangesForCountry = (e, { name, value }) => {
        this.props.updateNotesForCountry({ name, value });
    }

    render() {

        const {
            countryObject, editCountry, notesObject,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification
        } = this.props;

        return(
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Details:
                                </h4>
                                {editCountry
                                    ? null
                                    : (
                                        <Form.Group>
                                            <Form.Field>
                                                <label>Select Country To Add:</label>
                                                <Select
                                                    onChange={this.handleSelectCountry}
                                                    options={countryOptions}
                                                    placeholder="Countries"
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    value={lodash.find(countryOptions, {
                                                        value: countryObject.country_iso
                                                    })}
                                                />
                                            </Form.Field>
                                        </Form.Group>
                                    ) }
                                <Form.Group widths={"equal"}>
                                    <Form.Field required>
                                        <label>KYC Status</label>
                                        <Select
                                            onChange={this.handleCountryDetailDropdown}
                                            options={kycStatusOptions}
                                            placeholder="KYC Status"
                                            name="kyc_status"
                                            isClearable={true}
                                            value={lodash.find(kycStatusOptions, {
                                                value: countryObject.kyc_status
                                            })}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>KYC Tier</label>
                                        <Select
                                            onChange={this.handleCountryDetailDropdown}
                                            options={kycTierOptions}
                                            placeholder="KYC Tier"
                                            name="kyc_tier"
                                            isClearable={true}
                                            value={lodash.find(kycTierOptions, {
                                                value: countryObject.kyc_tier
                                            })}
                                        />
                                    </Form.Field>

                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Product Support:
                                </h4>
                                <div className="consent-details-container">
                                    <div className="form-item-container">
                                        <div className="form-equal-width-container">
                                            <p className="form-label">2x2 Support</p>
                                            <Toggle
                                                defaultChecked={countryObject.number_2x2_support}
                                                onChange={() =>
                                                    this.handleProductSupportToggle("number_2x2_support")
                                                }
                                            />
                                        </div>
                                        <div className="form-equal-width-container">
                                            <p className="form-label">Age Support</p>
                                            <Toggle
                                                defaultChecked={countryObject.age_support}
                                                onChange={() =>
                                                    this.handleProductSupportToggle("age_support")
                                                }
                                            />
                                        </div>
                                        <div className="form-equal-width-container">
                                            <p className="form-label">BV Support</p>
                                            <Toggle
                                                defaultChecked={countryObject.bv_support}
                                                onChange={() =>
                                                    this.handleProductSupportToggle("bv_support")
                                                }
                                            />
                                        </div>
                                        <div className="form-equal-width-container">
                                            <p className="form-label">BV+ Support</p>
                                            <Toggle
                                                defaultChecked={countryObject.bv_plus_support}
                                                onChange={() =>
                                                    this.handleProductSupportToggle("bv_plus_support")
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Indicative Match Rates:
                                </h4>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        required
                                        control={Input}
                                        type="text"
                                        label="1x1 Match Rate"
                                        placeholder="1x1 Match Rate"
                                        value={countryObject.number_1x1_match_rate === null ? "" : countryObject.number_1x1_match_rate}
                                        name="number_1x1_match_rate"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field
                                        required
                                        control={Input}
                                        type="text"
                                        label="2x2 Match Rate"
                                        placeholder="2x2 Match Rate"
                                        value={countryObject.number_2x2_match_rate === null ? "" : countryObject.number_2x2_match_rate}
                                        name="number_2x2_match_rate"
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Notes:
                                </h4>
                                { notesObject.length === 0  ? (
                                    <div>
                                        <p>No Notes have been added.</p>
                                    </div>
                                ) : (
                                    notesObject.map((note, idx) => {
                                        return (
                                            <div key={idx}>
                                                <h4>{note.type + " GDC Notes"}</h4>
                                                <DocumentEditor
                                                    initialValue={note.note}
                                                    country={true}
                                                    value={note.note}
                                                    notes={true}
                                                    resourceType={note.type}
                                                    placeholderText={note.type + " Notes Regarding This Country."}
                                                />
                                                <br />
                                            </div>
                                        )
                                    })
                                )
                                }
                            </Card.Content>
                        </Card>
                    </Form>
                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "10px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    countryObject: state.veritas.addEdit.addEditCountry.countryObject,
    notesObject: state.veritas.addEdit.addEditCountry.notesObject,
    editCountry: state.veritas.addEdit.addEditCountry.editCountry,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    updateNotesForCountry: ({ name, value }) => {dispatch(updateNotesFieldForCountry({ name, value }))},
    selectCountryDropdown: (country) => {dispatch(setCountry(country))},
    selectKYCDropdown: (option, change_obj) => {dispatch(setCountryDropdowns(option, change_obj))},
    toggleProductSupportValue: (product_type) => {dispatch(setProductSupport(product_type))},
    setMatchRates: ({name, value}) => {dispatch(setMatchRates({name, value}))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CountryForm)
